<bit-section>
  <bit-section-header>
    <h2 bitTypography="h6">{{ "loginCredentials" | i18n }}</h2>
  </bit-section-header>
  <bit-card>
    <bit-form-field [disableMargin]="!login.password && !login.totp">
      <bit-label>
        {{ "username" | i18n }}
      </bit-label>
      <input
        readonly
        bitInput
        type="text"
        [value]="login.username"
        aria-readonly="true"
        data-testid="login-username"
      />
      <button
        bitIconButton="bwi-clone"
        bitSuffix
        type="button"
        [appCopyClick]="login.username"
        [valueLabel]="'username' | i18n"
        showToast
        [appA11yTitle]="'copyValue' | i18n"
        data-testid="toggle-username"
      ></button>
    </bit-form-field>
    <bit-form-field [disableMargin]="!login.totp">
      <bit-label>{{ "password" | i18n }}</bit-label>
      <input
        readonly
        bitInput
        type="password"
        [value]="login.password"
        aria-readonly="true"
        data-testid="login-password"
      />
      <button
        bitSuffix
        type="button"
        bitIconButton
        bitPasswordInputToggle
        data-testid="toggle-password"
        (toggledChange)="pwToggleValue($event)"
      ></button>
      <button
        *ngIf="viewPassword && passwordRevealed"
        bitIconButton="bwi-numbered-list"
        bitSuffix
        type="button"
        data-testid="toggle-password-count"
        [appA11yTitle]="'toggleCharacterCount' | i18n"
        appStopClick
        (click)="togglePasswordCount()"
      ></button>
      <button
        bitIconButton="bwi-clone"
        bitSuffix
        type="button"
        [appCopyClick]="login.password"
        [valueLabel]="'password' | i18n"
        showToast
        [appA11yTitle]="'copyValue' | i18n"
        data-testid="copy-password"
      ></button>
    </bit-form-field>
    <ng-container *ngIf="showPasswordCount && passwordRevealed">
      <bit-color-password [password]="login.password" [showCount]="true"></bit-color-password>
    </ng-container>
    <bit-form-field disableMargin *ngIf="login.totp">
      <bit-label
        >{{ "verificationCodeTotp" | i18n }}
        <span
          *ngIf="!(isPremium$ | async)"
          bitBadge
          variant="success"
          class="tw-ml-2"
          (click)="getPremium()"
        >
          {{ "premium" | i18n }}
        </span>
      </bit-label>
      <input
        readonly
        bitInput
        type="text"
        [value]="login.totp"
        aria-readonly="true"
        data-testid="login-totp"
        [disabled]="!(isPremium$ | async)"
      />
      <button
        bitIconButton="bwi-clone"
        bitSuffix
        type="button"
        [appCopyClick]="login.totp"
        [valueLabel]="'verificationCodeTotp' | i18n"
        showToast
        [appA11yTitle]="'copyValue' | i18n"
        data-testid="copy-totp"
        [disabled]="!(isPremium$ | async)"
      ></button>
    </bit-form-field>
  </bit-card>
</bit-section>
